import { render, staticRenderFns } from "./fee-modal.vue?vue&type=template&id=e52605c0&"
import script from "./fee-modal.vue?vue&type=script&lang=js&"
export * from "./fee-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports